import { GridAction } from '@eforall/dashboard';
import { TrimesterCost } from '@interfaces';

export function getActions() {

	const actions: GridAction<TrimesterCost>[] = [];

	return actions;
}